import { createJsonHttpRequest, authTokenHandler, zipkinTraceHandler } from '@jutro/transport';
import { getConfigValue } from '@jutro/config';
var zipkinHandler = zipkinTraceHandler('TSM', 'Jutro with TSM');
export var createTSMRequest = function createTSMRequest(serverUrl) {
  return createJsonHttpRequest(serverUrl, false).addHandler(zipkinHandler).addHandler(authTokenHandler);
};
export var isTSMEnabled = function isTSMEnabled() {
  return getConfigValue('JUTRO_AUTH_ENABLED', false) && getConfigValue('JUTRO_TSM_ENABLED', false);
};